export class ContactPersons {
  ContactPersonID?: number;
  Title: string;
  Name: string;
  Postion: string;
  Department: string;
  RelatedToID: number;
  CompanyBranchID: number;
  ContactPersonRelatedTypeID: number;
  Phone?: string;
  Mobile?: string;
  Email?: string;
  Fax?: string;
  Website?: string;
  OnlineSupport?: string;
  Comments?: string;
  ImgPath?: string;
  ContactReferences?: ContactPersonReference[];
  ContactInfoList: ContactInfo[];
  CreatedAt?: Date;
  CreatedBy?: string;
  ModifiedAt?: Date;
  ModifiedBy?: string;
  // AccountID: number;
  Account?: string;
  //frontend variable
  _isSelected?: boolean;
}
export class ContactPersonReference {
  ContactPersonReferenceID: number;
  ContactPersonID: number;
  ContactPersonRelatedTypeID: number;
  RelatedToID: number;
}

export interface ContactInfo {
  ContactInfoTypeID: number;
  ContactInfoValue: string;
  Name: string;
  ContactInfoID?: number;
  OrderNumber?: number;
  IsDefault?: boolean;
  RelatedTypeID?: number;
  RelatedToID?: number;
  IsVerified?: boolean;
  VerificationHash?: string;
}
export enum ContactInfoTypeEnum {
  Phone = 1,
  Fax = 2,
  Mobile = 3,
  Email = 4,
  Website = 5,
  OnlineSupport = 6,
  Comments = 8,
}
export class AccountLookup {
  FullName: string;
  ID: number;
  Name: string;
  IsClient?: boolean;
  IsPrincipal?: boolean;
  IsSubsupplier?: boolean;
}